<template>
  <WrapperFormElements
    :label
    :required
    :hint
    :alertLabel
    :alertType
  >
    <BasicDropdownMultiple
      v-model="modelValue"
      :items
      :disabled
      :placeholder
      :size
      :readonly
      :deletable
      :key-id="keyId"
      :key-label="keyLabel"
      :item-id="itemId"
    />
  </WrapperFormElements>
</template>

<script setup lang="ts" generic="TDropdownItem extends DropdownMultipleItem = DropdownMultipleItem">
  import type {
    DropdownId,
    DropdownSize,
    DropdownType,
    WrapperFormElementProps,
    DropdownMultipleItem,
  } from '@designSystem/components'
  import type { AlertType } from '@designSystem/components/basic/alert'

  type WrapperDropdownMultipleProps<T = DropdownMultipleItem> = WrapperFormElementProps & {
    items?: T[]
    keyId?: (keyof T)[]
    keyLabel?: (keyof T)[]
    placeholder?: string
    size?: DropdownSize
    disabled?: boolean
    readonly?: boolean
    dropdownType?: DropdownType
    deletable?: boolean
    alertType?: AlertType
    alertLabel?: string | null
    itemId?: (item: T) => DropdownId
  }

  withDefaults(defineProps<WrapperDropdownMultipleProps<TDropdownItem>>(), {
    deletable: true,
  })

  const modelValue = defineModel<DropdownId[]>()
</script>
